
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { ArticleFormValues } from "./ArticleEditor";
import { Control } from "react-hook-form";
import { Category } from "./hooks/useArticleCategories";

interface Props {
  control: Control<ArticleFormValues>;
  categories: Category[];
}

export default function ArticleEditorCategory({ control, categories }: Props) {
  return (
    <FormField
      control={control}
      name="category_id"
      rules={{ required: "Category is required" }}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-white/90">Category</FormLabel>
          <Select
            onValueChange={field.onChange}
            defaultValue={field.value}
            value={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select category" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {categories.map((category) => (
                <SelectItem key={category.id} value={category.id}>
                  {category.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
